export const shiftJISDecoder = new TextDecoder('shift-jis')
export const utf8Decoder = new TextDecoder('utf-8')
export const utf16LEDecoder = new TextDecoder('utf-16le')
